import React, { useEffect, useRef, useState } from "react";
import { _vendorAdminRoutes } from "../../../utils/appRouter";
import { apiUrl } from "../../../utils/endPoints/apiUrl";
import { useDispatch, useSelector } from "react-redux";
import { fetchShopList } from "../../../store/slices/shopSlice";
import DeleteHandler from "../../../component/comman/DeleteHandler";
import {PageInfoHeader} from "../../../component/comman/PageInfoHeader"; 
import Pagination from "../../../comman/Pagination";

const BranchListing = () => {

  const { shopListing, isLoading, filter } = useSelector((state) => state.shops);
  const dispatch = useDispatch();
  const deleteRef = useRef(null);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const limit = 5;


useEffect(() => {
  const handler = setTimeout(() => {
    dispatch(fetchShopList({ ...filter, searchQ: search,page, limit }));
  }, 500);

  return () => clearTimeout(handler);
}, [search, filter, page]);

  return (
    <section className="content mb-5">
      <div className="container-fluid">
        <div className="row titlepad">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>

            <div className="row align-items-end">
              <div className="col-sm-9">
                <h4>Branches</h4>
                 <PageInfoHeader
                  page={page}
                  limit={limit}
                  total={shopListing?.count || 0}
                  label="list of branches"
                />
                <a
                  href={_vendorAdminRoutes.addBranch}
                  className="btn-md btn-primary d-inline-block"
                >
                  <i className="fa-solid fa-user-plus"></i> Add More
                </a>{" "}
                {/* <a href="#" className="btn-md btn-info d-inline-block">
                  <i className="fa-regular fa-file-excel"></i> Export
                </a>{" "}
                <a
                  href="#"
                  data-toggle="modal"
                  data-target="#filter"
                  className="btn-md btn-dark d-inline-block"
                >
                  <i className="fa-solid fa-filter"></i> Filter
                </a> */}
              </div>
              <div className="col-md-3">
                <input
                  className="form-control searchinput"
                  type="text"
                  placeholder="Search Branch..."
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="table-responsive bg-white">
              {!isLoading ? <table
                className="table table-striped table-bordered admintable border-0"
                cellspacing="0"
                cellpadding="0"
              >
                <tbody>
                  <tr>
                    <th>#</th>
                    <th>Branch Name</th>
                    {/* <th>Contact Person</th> */}
                    {/* <th>Email</th>
                    <th>Mobile</th> */}
                    <th>Shop Type</th>
                    {/* <th>Created On</th> */}
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                  {shopListing.rows.length ? shopListing.rows?.map((shop, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{shop?.name}</td>
                      {/* <td>{shop?.userId?.name || "--"}</td> */}
                      {/* <td>{shop?.userId?.email || "--"}</td>
                      <td>{shop?.userId?.mobileNo || "--"}</td> */}
                      <td>{shop?.shopType || "--"}</td>
                      {/* <td>{shop?.shopType || "--"}</td> */}
                      <td>
                        <span className="badge bad-status badge-success">
                          {shop?.status}
                        </span>
                      </td>
                      <td>
                        <a href={_vendorAdminRoutes.branchDetails(shop._id)} className="f-16 mr-1">
                          <i className="fa-solid fa-pen-to-square"></i>
                        </a>
                         {/* <DeleteHandler
                          heading="Confirm Branches"
                          content="Are you sure you want to delete this Branches?"
                          apiUrl={apiUrl.staff.root}
                          id={shop?._id}
                          // onDelete={() => dispatch(fetchStaffList({ paginate: "" }))} 
                          showTriggerButton={false} 
                          ref={deleteRef}
                          />
                           <a
                            href="#"
                            className="text-danger f-16"
                            onClick={(e) => {
                              e.preventDefault();
                              deleteRef.current?.openModal(); 
                            }}
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </a> */}
                      </td>
                    </tr>
                  ))
                : <tr>
                  <td colSpan={9} className="text-center py-4">
                      {isLoading ? 'Loading...' : 'No branches found.'}
                  </td>
               </tr>}

                  
                </tbody>
              </table> : <p>Loading...</p>}
            </div>
          </div>

          <Pagination
            page={page}
            limit={limit}
            total={shopListing?.count || 0}
            onPageChange={(newPage) => setPage(newPage)}
            showAlways={true}
          />

        </div>
      </div>
    </section>
  );
};

export default BranchListing;
